import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { normalizeRole, type Role } from '@/auth/permissions';
import { clearSession, getSession } from '../lib/session';
import { getHomePathForRole } from '../utils/roleRouting';
import { toast } from '@/lib/toast';

interface RequireAuthByRoleProps {
  role: Role;
}

export function RequireAuthByRole({ role }: RequireAuthByRoleProps) {
  const location = useLocation();

  const session = getSession();
  if (!session?.token || !session?.user) {
    clearSession();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const userRole = normalizeRole(session.user.role);
  const requiredRole = normalizeRole(role);
  if (userRole === requiredRole) {
    return <Outlet />;
  }

  if (requiredRole === 'VENDEDOR' && userRole === 'ADMIN') {
    return <Outlet />;
  }

  if (normalizeRole(session.user.role) === 'CONSULTA') {
    toast('No tienes permisos', 'warning');
    return <Navigate to="/inventario" replace />;
  }

  const home = getHomePathForRole(session.user.role);
  return <Navigate to={home} replace />;
}

export default RequireAuthByRole;
